module.exports = __webpack_public_path__ + "static/nobull-a2b7380fe1dea22aa9722ce79ba1f736.png";